import Dictionary from "../../dictionary/dictionary";
import {ShipownerModel} from "../../../models/shipowners";
import {ShipownerService} from "../../../services/shipownerService";
import i18n from "../../../../i18n/i18n";
import {Api} from "../../../../helpers/api";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../../helpers/routing";
import Button from "../../../../common/components/shared/button/button";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {SortDirection} from "../../../../common/models/table";

export default class ShipownersList extends Dictionary<ShipownerModel> {
    private sortableElements = ["name", "taxNo", "phoneNo", "street", "city", "postalCode", "imoCode"];

    constructor(props: any) {
        super(props);

        this.canRemove = true;
        this.linkToModify = routingAddresses.dictionaries.shipowners.modify;
    }

    public async componentDidMount() {
        this.getData((await ShipownerService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    public render(): JSX.Element {
        const properties = ["name", "taxNo", "phoneNo", "street", "city", "postalCode", "countryName", "imoCode"];
        const headers = properties.map(key => i18n.t("dictionaries.shipowners.headers." + key));
        const actions = this.renderActions;

        return (
            <div className="shipowners">
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
                {this.renderWrapperContent(headers, properties, "shipowners", actions, undefined, this.getHeader(), this.sortableElements, this.sortingAction.bind(this))}
            </div>
        );
    }

    private getHeader() {
        return (
            <div className="actions">
                <NavLink to={routingAddresses.dictionaries.shipowners.add} data-testid="add-shipowner">
                    <Button type="primary" text={i18n.t("dictionaries.shipowners.actions.addShipowner.button")}/>
                </NavLink>
                <ReloadButton
                    reloadFunc={this.reload.bind(this)}
                    testId="shipowner-list-reload-btn"
                />
            </div>
        );
    }

    private async reload() {
        this.reloadList((await ShipownerService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    protected async confirmRemove() {
        this.setState({removeItemResponse: undefined, isWaiting: true});

        const response = await ShipownerService.removeShipowner(this.state.selectedElement!.id);

        this.setState({removeItemResponse: response});

        if (Api.isSuccess(response)) {
            await this.getData((await ShipownerService.getAll({
                orderBy: this.state.orderBy,
                sortDirection: this.state.sortDirection
            })));
            this.setState({selectedElement: undefined, displayRemovePopup: false});
        } else {
            this.setState({errorMessage: i18n.t("dictionaries.shipowners.errors.removeErrorSuffix")});
        }
        this.setState({isWaiting: false});
    }

    private async sortingAction(orderBy: string, sortDirection: SortDirection) {
        await this.setState({orderBy, sortDirection});
        await this.reload();
    }
}


